import { OrderedMap, Map } from 'immutable';
import { types as buildsTypes, records as buildsRecords } from '@saucelabs/sl-module-builds';
import { records as jobRecords, types as jobsTypes, utils as jobUtils } from '@saucelabs/sl-module-jobs';

import { PERFORMANCE_DEFAULT } from './constants';

import { types } from '.';

export const initialState = Map({
  build: new buildsRecords.BuildRecord(),
  jobs: OrderedMap(),
  loading: true,
  pollerId: 0,
  truncated: true,
  perfMetrics: Map(),
  performanceFilter: PERFORMANCE_DEFAULT,
});

const buildsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case buildsTypes.BUILD_GET.SUCCESS:
      return state
        .set('build', new buildsRecords.BuildRecord({
          ...payload,
          status: payload.status || 'new',
        }))
        .set('loading', false);
    case buildsTypes.BUILD_JOBS_GET.SUCCESS: {
      let jobs = state.get('jobs');
      payload.jobs.forEach((job) => {
        jobs = jobs.update(
          job.id,
          [job.id, new jobRecords.JobRecord(job)],
          (jobRecord) => new jobRecords.JobRecord({ ...jobRecord, ...job }),
        );
      });
      return state
        .set('jobs', jobs)
        .set('truncated', payload.truncated);
    }
    case buildsTypes.BUILD_UPDATED_JOBS_GET.SUCCESS: {
      let jobs = state.get('jobs');
      payload.jobs.forEach((job) => {
        jobs = jobs.update(
          job.id,
          [job.id, new jobRecords.JobRecord(job)],
          (jobRecord) => new jobRecords.JobRecord({ ...jobRecord, ...job }),
        );
      });
      return state.set('jobs', jobs);
    }
    case types.CLEANUP:
      return initialState;
    case types.SAVE_BUILDS_TIMEOUT:
      return state.set('pollerId', payload);
    case types.UNSUBSCRIBE_BUILDS: {
      clearTimeout(state.get('pollerId'));
      return state.set('pollerId', initialState.get('pollerId'));
    }
    case types.TOGGLE_PERFORMANCE: {
      return state.set('performanceFilter', payload);
    }
    case jobsTypes.PERF_METRICS_GET.SUCCESS: {
      const jobs = state.get('jobs');
      if (payload?.items?.length && jobs?.size) {
        const perfMetrics = jobUtils.groupPerformanceByJobId(payload.items);
        const jobsListIncludingPerf = jobUtils.addPerformanceMetricsInJobs({
          perfMetrics, jobs,
        });
        return state.withMutations((mutable) => (
          mutable
            .set('jobs', jobsListIncludingPerf)
            .set('perfMetrics', Map(perfMetrics))
        ));
      }
      return state;
    }
    case jobsTypes.PERF_METRICS_GET.FAILURE:
    default:
      return state;
  }
};

export default buildsReducer;
